import React, { Component } from 'react'
import ConnectLink from '../components/ConnectLink'
import { popUp } from '../helpers'
import { SHOPIFY_INTEGRATION_URL } from 'constants/ResourcesConstants'

class ShopifyInstaller extends Component {

  handleConnect = () => {
    popUp({ path: SHOPIFY_INTEGRATION_URL })
  }

  render() {
    return (
      <div>
        <p>Install Drift on your Shopify store with one click. Connect and authorize
          Shopify to embed Drift chat in your Shopify store.</p>
        <ConnectLink handleConnect={this.handleConnect} connectorType="button" buttonType="tertiary"/>
      </div>
    )
  }
}

export default ShopifyInstaller



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/ShopifyInstaller.js